module.exports = __webpack_public_path__ + "img/191.71648c77.jpg";